<app-modal [title]="'Pré-visualização do formulário'" (onCloseClick)="fechar()"
    [saveLabel]="'Pré-Visualizacao'" [hideFooter]="true" [hideCancel]="true">
    
    <p class="pre-visualizacao-texto">
        Aqui você pode ver uma amostra do que o candidato verá quando clicar na avaliação de requisito. Essa é uma
        pré-visualização, ou seja, uma visualização antecipada do conteúdo.
    </p>

    <div class="preview-box">
        <div *ngFor="let pergunta of perguntas; let i = index">
            <p class="pergunta-titulo">Pergunta {{ i + 1 }}</p>
            <mat-divider class="mb-8"></mat-divider>

            <div class="form-group">
                <label class="pergunta-texto">{{ pergunta.avaliacao }}</label>
                <div *ngFor="let item of pergunta.possiveisRespostasAvaliacaoRequisito" class="radio-group">
                    <input type="radio" [id]="'resposta' + i + item.resposta" name="'pergunta' + i">
                    <label [for]="'resposta' + i + item.resposta" class="resposta-texto">{{ item.resposta }}</label>
                </div>
            </div>
        </div>
    </div>
</app-modal>
